const definition={
	vipTierBenefits:[
		{
			benefit:"Merchandise giveaway",
			level1:"",
			level2:"•",
			level3:"•",
		},
		{
			benefit:"Exclusive offers",
			level1:"",
			level2:"",
			level3:"•",
		},
	],
	refferalForm:{
		exictingUserForm:{
			text:"Now, enter your friends' emails.",
			placeolder:"Your friends' emails (separated by commas)",
			submittext:"SEND",
			formtype:"exicting"
		},
		newUserForm:{
			text:"Enter your email to get started.",
			placeolder:"Your email...",
			submittext:"NEXT",
			formtype:"new"
		},
	},
	shareLinks:[
		{
			text:"Share",
			icon:"fab fa-facebook-f",
			href:"javascript:void(0)",
			class:"swell-share-referral-facebook",
		},
		{
			text:"SMS",
			icon:"fas fa-comment-alt",
			href:"javascript:void(0)",
			class:"swell-share-referral-sms",
		},
		{
			text:"Message",
			icon:"fab fa-facebook-messenger",
			href:"javascript:void(0)",
			class:"swell-share-referral-messenger",
		},
		{
			text:"Tweet",
			icon:"fab fa-twitter",
			href:"javascript:void(0)",
			class:"swell-share-referral-twitter",
		},
		{
			text:"Copy Link",
			icon:"fa fas fa-link",
			href:"javascript:void(0)",
			class:"swell-share-referral-copylink",
		},

	],
}